import request from '@/utils/request'

export function addAutomaticQuotation(data) {
    return request({
        url: `api/serviceCenter/automaticQuotation/addAutomaticQuotation`,
        method: 'post',
        data,
    })
}

export function selectWebAutomaticQuotation(data) {
    return request({
        url: `api/serviceCenter/automaticQuotation/selectWebAutomaticQuotation`,
        method: 'post',
        data,
    })
}

export function bathDelete(data) {
    return request({
        url: `api/serviceCenter/automaticQuotation/bathDelete`,
        method: 'post',
        data,
    })
}

export function updateAutomaticQuotation(data) {
    return request({
        url: `api/serviceCenter/automaticQuotation/updateAutomaticQuotation`,
        method: 'post',
        data,
    })
}
export function getAllCategory(data) {
    return request({
        url: `api/serviceCenter/pieceworkSet/getAllCategory?access=${data}`,
        method: 'get',
    })
}
